//ToDo: Reftactor the comonent and creat a general intentions separate component for it.
//ToDo: API integration.
import { Box, VStack, HStack, Text, useDisclosure } from "@chakra-ui/react";
import React, {
  useState,
  useMemo,
  useRef,
  useEffect,
  useCallback,
} from "react";
import BaseView from "src/views/Prepration/BaseView";
import { affirmationBg } from "src/assets/icons";
import SpecialIntentions from "./SpecialIntentions";
import Link from "src/components/Link/Link";
import { FormattedMessage, useIntl } from "react-intl";
import StoppedIntentionModel from "./StoppedIntentionModel";
import GeneralIntentions from "./GeneralIntentions";
import { timeoutCollection } from "time-events-manager";
import { useSelector, useDispatch } from "src/store";
import {
  toggleIsBtn,
  endDateValue,
  toggleBlinkValue,
  setMessage,
  startDateValue,
} from "src/store/media";
import SharingModal from "src/components/SharingModal/SharingModal";
import { useHistory } from "react-router-dom";
import { MessageProvider } from "./MessageContext";
import { useIntentionTimer } from "./hooks/useIntentionTimer";
import {
  MAIN_CONTAINER_RESPONSIVE_WIDTH,
  RESPONSIVE_SPACING,
  RESPONSIVE_PADDING,
} from "./utils";

const Intention = () => {
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [disableSendIntentionBtn, setDisableSendIntentionBtn] =
    useState<boolean>(true);
  const [intentionCount, setIntentionCount] = useState<number>(0);
  const node = React.useRef<HTMLDivElement>(null);
  const { endDateString, startDateString, messageValue, blink } = useSelector(
    (state) => ({
      endDateString: state.media.endDate,
      blink: state.media.blink,
      messageValue: state.media.messageValue,
      startDateString: state.media.startDate,
    })
  );

  // Use our custom timer hook for proper timer management
  const { days, hours, minutes, seconds } = useIntentionTimer({
    isActive: blink && !!messageValue,
    startDate: startDateString,
    intentionName: messageValue,
  });
  const startDate = useMemo(() => new Date(startDateString), [startDateString]);
  const endDate = useMemo(() => new Date(endDateString), [endDateString]);
  const intl = useIntl();
  const history = useHistory();
  const pageUrl = history.location.pathname;

  // Callback to trigger re-render when intention is added
  const handleIntentionAdded = useCallback(() => {
    setIntentionCount((prev) => prev + 1);
  }, []);

  const handleLinkBlink = () => {
    if (messageValue && !blink) {
      dispatch(toggleIsBtn({ value: true }));
      dispatch(startDateValue({ value: String(new Date()) }));
      return dispatch(toggleBlinkValue({}));
    }
    dispatch(endDateValue({ value: String(new Date()) }));

    // Clear any existing timers - the custom hook will handle cleanup
    const storedInterval = window.localStorage.getItem("intentionTimeInterval");
    if (storedInterval) {
      window.clearInterval(Number(storedInterval));
      window.localStorage.removeItem("intentionTimeInterval");
    }

    timeoutCollection.removeAll();
    dispatch(toggleIsBtn({ value: false }));
    window.localStorage.removeItem("intentionMessage");
    blink ? onOpen() : dispatch(setMessage({ value: undefined }));
    return dispatch(toggleBlinkValue({}));
  };

  const handleCloseModal = () => {
    dispatch(endDateValue({ value: String(new Date()) }));
    onClose();
    dispatch(setMessage({ value: undefined }));
    setDisableSendIntentionBtn(true);
  };

  const handleMessage = (e: any) => {
    dispatch(setMessage({ value: e.target.value }));
    !blink && window.localStorage.setItem("intentionMessage", e.target.value);
    setDisableSendIntentionBtn(false);
  };
  const {
    isOpen: isSharingModalOpen,
    onClose: onSharingModalClose,
    onOpen: onSharingModalOpen,
  } = useDisclosure();
  const [currentList, setCurrentList] = useState<any>({ id: 0, name: "" });
  const onShare: any = (item) => {
    onSharingModalOpen();
    setCurrentList(item);
  };
  return (
    <MessageProvider>
      <Box id={"intentions-container"}>
        <BaseView imageSrc={affirmationBg} />
        <Box
          display="flex"
          flexDir="column"
          alignItems="center"
          width="100%"
          paddingTop="50px"
        >
          {/* @ts-ignore */}
          <HStack
            flexWrap={["wrap", "wrap", "wrap", "nowrap"]}
            justify={["center", "center", "center", "space-between"]}
            maxWidth={MAIN_CONTAINER_RESPONSIVE_WIDTH}
            alignItems={"flex-start"}
            me={["10px", "-54px", "-10px"]}
            spacing={RESPONSIVE_SPACING}
            px={RESPONSIVE_PADDING}
          >
            <div ref={node}>
              <SpecialIntentions
                share={onShare}
                onClick={handleMessage}
                name={blink ? "" : messageValue}
                onIntentionAdded={handleIntentionAdded}
              />
            </div>
            <div ref={node}>
              <GeneralIntentions onClick={handleMessage} />
            </div>
          </HStack>

          <VStack mb={".3rem"} spacing={0}>
            {/*/css for this is in app.css!*/}
            <Text
              className={blink ? "blink_intention" : "normal_intention"}
              textAlign={"center"}
              mt={"16px"}
              textStyle={"intentionDisplayText"}
            >
              {messageValue}
            </Text>
            <HStack>
              <Text textStyle={"intentionModalTime"}>
                {intl.formatMessage({ id: "day" })} ({days})
              </Text>
              <Text textStyle={"intentionModalTime"}>
                {intl.formatMessage({ id: "hour" })} ({hours})
              </Text>
              <Text textStyle={"intentionModalTime"}>
                {intl.formatMessage({ id: "minute" })} ({minutes})
              </Text>
              <Text textStyle={"intentionModalTime"}>
                {intl.formatMessage({ id: "second" })} ({seconds}){" "}
              </Text>
            </HStack>

            <div>
              <Link
                id={"sendInentionBtn"}
                disabled={disableSendIntentionBtn && !blink}
                onClick={handleLinkBlink}
                asBtn={true}
                my={1}
              >
                {blink ? (
                  <FormattedMessage id="stop" defaultMessage={"إيقاف"} />
                ) : (
                  <FormattedMessage id="send" defaultMessage={"إرسال"} />
                )}
              </Link>
            </div>
          </VStack>
          <StoppedIntentionModel
            startDate={startDate}
            endDate={endDate && endDate}
            isOpen={isOpen}
            onClose={handleCloseModal}
            title={messageValue}
            content={
              <FormattedMessage
                id="stoppedintention"
                defaultMessage={"تم إيقاف النية المرسله"}
              />
            }
          />
        </Box>
        <SharingModal
          isOpen={isSharingModalOpen}
          onClose={onSharingModalClose}
          sharedEntity={{ name: "intention", id: currentList.id }}
          showOptions={false}
        />
      </Box>
    </MessageProvider>
  );
};

export default Intention;
